import cx from "classnames";
import Button from "../Button/Button";
import { getSpotLink } from "../../services/linkGenerator";
import styles from "./CheckSpotsList.module.scss";
import PropTypes from "prop-types";

const CheckSpotsList = ({ spots, getItemToEdit, clearSearch }) => {
	const spotsInList = 1000;
	return (
		<>
			{spots?.length > 0 && (
				<div className={styles.linksContainer}>
					<h6>Do you want to edit an existing spot?</h6>
					{spots.slice(0, spotsInList).map((spot, index) => (
						<div key={`${spot.key}${index}`} className={styles.spotItem} >
							<a
								className={styles.link}
								key={`${spot.key}`}
								target="_blank"
								href={getSpotLink(spot.type, spot.name, spot.key)}
							>
								{spot.name}
							</a>
							<div className={cx(styles.item)}> {spot.key}</div>
							<div className={cx(styles.item)}> {spot.type}</div>
							<Button
								onClick={() => {
									getItemToEdit({ type: spot.type, key: spot.key });
									clearSearch && clearSearch();
								}}
								className={cx(styles.editButton)}
							>
								Edit
							</Button>
						</div>
					))}
				</div>
			)}
		</>
	);
};

export default CheckSpotsList;